'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _setInterval = require('common/utils/set-interval');

var _setInterval2 = _interopRequireDefault(_setInterval);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

require('./index.scss');

var Loader = _react2['default'].createClass({
    displayName: 'Loader',
    getInitialState: function getInitialState() {
        return {
            'numCircles': 5,
            'currentIndex': 0,
            'circleRadius': 10
        };
    },
    componentDidMount: function componentDidMount() {

        var numBubbles = this.refs.dots.querySelectorAll('circle').length;
        var i = 0;

        this._timer = (0, _setInterval2['default'])(function () {
            this.setState({
                'currentCircleIndex': i
            });
            i = (i + 1) % numBubbles;
        }.bind(this), 500);
    },
    componentWillUnmount: function componentWillUnmount() {
        clearInterval(this._timer);
    },
    render: function render() {

        var circles = [];
        var radius = this.state.circleRadius;
        var circWidth = radius * 2;
        var padding = radius;

        // width and padding
        var wandp = circWidth + padding;

        for (var i = this.state.numCircles; i--;) {
            circles.push(_react2['default'].createElement('circle', {
                key: 'circle' + i,
                className: i === this.state.currentCircleIndex ? 'current-dot' : void 0,
                ref: '5',
                cx: wandp * i + radius,
                cy: radius,
                r: radius }));
        }

        var width = wandp * circles.length - padding;
        var classNames = ' m-loader-dots whitelabel-dot-loader';

        if (this.props.className) {
            classNames += ' ' + this.props.className;
        }

        return _react2['default'].createElement(
            'div',
            { className: classNames },
            _react2['default'].createElement(
                'svg',
                { width: '100%', viewBox: '0 0 ' + width + ' ' + circWidth, version: '1.1' },
                _react2['default'].createElement(
                    'g',
                    { ref: 'dots' },
                    circles
                )
            ),
            this.props.children ? _react2['default'].createElement(
                'span',
                { className: 'message' },
                this.props.children
            ) : void 0
        );
    }
});

module.exports = Loader;


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/loader/index.jsx
 ** module id = 798
 ** module chunks = 0 1
 **/